export default "__VITE_ASSET__CchBz6ck__"